// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "disclaimer-2NDGn";
export { _1 as "__esModule", _2 as "disclaimer" }
export default { "__esModule": _1, "disclaimer": _2 }
